import React from 'react';

import { Body } from '@depop/web-thrift-ui/Typography';

import { ToolButton } from '../../components/ToolButton';

import styles from './styles.module.css';

import { type Tools } from '@/modules/adminTool/types.ts';

type Props = {
  title: string;
  collection: Tools;
  onToolClick: (label: string) => void;
};

export function ToolCollection({ collection, title, onToolClick }: Props) {
  return (
    <>
      <Body variant="sm-bold">{title}</Body>
      <div className={styles.buttons}>
        {Object.keys(collection).map((label) => (
          <ToolButton
            key={label}
            label={label}
            icon={collection[label].icon}
            onClick={() => onToolClick(label)}
          />
        ))}
      </div>
    </>
  );
}
